import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import {
  GetCmsMessagesResponse,
  GetCmsNewsItemResponse,
  GetCmsNewsResponse,
  GetCmsPromotionItemResponse,
  GetCmsPromotionsResponse
} from './index'

export const getCmsBanners = ({ orderAccountUUID }: { orderAccountUUID: string }) => ({
  method: 'GET',
  url: '/modules/cms/banners',
  params: { OrderAccountUUID: orderAccountUUID }
})

export const getCmsMessages = ({ orderAccountUUID }: { orderAccountUUID: string }) => ({
  method: 'GET',
  url: '/modules/cms/messages',
  params: { OrderAccountUUID: orderAccountUUID }
})

export const getNationalCmsBanners = () =>
  createAsyncApiAction<GetCmsMessagesResponse>('gms', {
    method: 'GET',
    url: '/modules/cms/national-banner'
  })

export const GetCmsNews = ({ orderAccountUUID, page, perPage }: { orderAccountUUID: string; page: number; perPage: number }) =>
  createAsyncApiAction<GetCmsNewsResponse>('gms', {
    method: 'GET',
    url: '/modules/cms/news',
    params: { OrderAccountUUID: orderAccountUUID, Page: page, PerPage: perPage }
  })

export const GetCmsNewsItem = ({ orderAccountUUID, id }: { orderAccountUUID: string; id: string }) =>
  createAsyncApiAction<GetCmsNewsItemResponse>('gms', {
    method: 'GET',
    url: `/modules/cms/news/${id}`,
    params: { OrderAccountUUID: orderAccountUUID }
  })

export const GetCmsPromotions = ({ orderAccountUUID, page, perPage }: { orderAccountUUID: string; page: number; perPage: number }) =>
  createAsyncApiAction<GetCmsPromotionsResponse>('gms', {
    method: 'GET',
    url: '/modules/cms/promotions',
    params: { OrderAccountUUID: orderAccountUUID, Page: page, PerPage: perPage }
  })

export const GetCmsPromotionItem = ({ orderAccountUUID, id }: { orderAccountUUID: string; id: string }) =>
  createAsyncApiAction<GetCmsPromotionItemResponse>('gms', {
    method: 'GET',
    url: `/modules/cms/promotions/${id}`,
    params: { OrderAccountUUID: orderAccountUUID }
  })
